import React, { useState, useEffect } from 'react';
// import { AuthContext } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './mycss.css';
import Apiconnect from "../services/Apiconnect.js";


const Register = () => {
   const [bgimg, setBgimg] = useState('');
   const [passwordVisible, setPasswordVisible] = useState(false);

   const [strems, setStreams] = useState([]);
   const [classes, setClasses] = useState([]);
   const [infoz, setInfoz] = useState({ fname: "", lname: "", email: "", phone: "", password: "" });
   const { fname, lname, email, phone, password, } = infoz;
   const [isLoading, setIsLoading] = useState(false);


   const navigate = useNavigate();

   useEffect(() => {

      const randomImageUrl = getRandomImage();
      setBgimg(randomImageUrl);
   }, [setBgimg]);


   const getRandomImage = () => {
      const randomNum = Math.floor(Math.random() * 9) + 1; // Generates a number between 1 and 9
      return `admin_codebase/bgpic1.jpg`;
   };
   const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
   };


   const onInputChange = e => {
      setInfoz({ ...infoz, [e.target.name]: e.target.value });
      //console.log(infoz); 
   };



   const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try {
         await Apiconnect.postDataNoauth("auth/register", infoz).then((response) => {
            console.log(response.data);
            if (response.data.status == 1) {
               setInfoz({ fname: "", lname: "", email: "", phone: "", password: "", password: "" });
               toast('Registered Successfully');
               localStorage.setItem("email", email);
               setTimeout(() => {
                  navigate("/customer_verify", { replace: true });
               }, 2000);
            } else {
               toast.error(response.data.message);
            }
            setIsLoading(false);
         });

      } catch (error) {
         var err = 'Somthing went wrong!!';
         if (error.response) {
            console.log('Response error:', error.response.data);
            console.log('Response status:', error.response.status);
            console.log('Response headers:', error.response.headers);
         } else if (error.request) {
            console.log('Request error:', error.request);
         } else {
            console.log('General error:', error.message);
         }

         toast.error(err);
      }
   };

   return (
      <>



         <div class="container-fluid p-0 vh-100"  >
            <div class="row g-0 vh-100">
               <div class="col-xl-7 example"
                  style={{
                     backgroundImage: `url(${bgimg})`,
                  }}

               >

               </div>

               <div class="col-xl-5 vh-100" >
                  <div class="auth-full-page-content p-md-5 p-4"  >
                     <div class="w-100 p-5" >

                        <div class="text-center">
                           <img style={{ maxWidth: '50%', marginBottom: 30, }} src="admin_codebase/b-logo.png" />
                           <h6>Are you New Here? Register Now</h6>
                           {/* <h2><b></b></h2>  */}
                        </div>

                        <form onSubmit={handleSubmit} >

                           <div class="row">


                              <div class="col-md-12">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginName">First Name *</label>
                                    <input type="text"
                                       name="fname" value={fname} onChange={e => onInputChange(e)}
                                       class="form-control inp" placeholder="Enter Your First Name" required />
                                 </div>
                              </div>

                              <div class="col-md-12">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginName">Last Name *</label>
                                    <input type="text"
                                       name="lname" value={lname} onChange={e => onInputChange(e)}
                                       class="form-control inp" placeholder="Enter Your Last Name" required />
                                 </div>
                              </div>

                              <div class="col-md-12">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginName">Phone *</label>
                                    <input type="text"
                                       name="phone" value={phone} onChange={e => onInputChange(e)}
                                       class="form-control inp" placeholder="Enter Your Phone" required />
                                 </div>
                              </div>



                              <div class="col-md-6">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginName">Email Address *</label>
                                    <input type="email"
                                       name="email" value={email} onChange={e => onInputChange(e)}
                                       class="form-control inp" placeholder="Enter Your Email" required />
                                 </div>
                              </div>
                              <div class="col-md-6">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginPassword">Password *</label>
                                    <div class="input-group">
                                       <input
                                          type={passwordVisible ? 'text' : 'password'}
                                          className="form-control inp"
                                          minLength="8"
                                          placeholder="Enter Your Password"
                                          name="password" value={password} onChange={e => onInputChange(e)}
                                          required
                                       />
                                       <button type="button" className="btn btn-secondary" onClick={togglePasswordVisibility}>
                                          <i id="akhi" className={`fa ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                       </button>
                                    </div>
                                 </div>
                              </div>


                           </div>

                           <div class="form-outline mb-4">
                              <label class="form-label" for="form1Example23"></label>
                              <input
                                 type="submit"
                                 id=""
                                 class="form-control form-control-lg btn btn-primary submit"
                                 value={isLoading ? "Please wait..." : "Register"}
                                 disabled={isLoading}
                              />
                           </div>


                           <div   >

                              <a href="/">Back to Login</a>
                           </div>

                        </form>






                     </div>
                  </div>
               </div>
            </div>
         </div>


         <ToastContainer />
      </>
   );
};

export default Register;
